module.exports = __webpack_public_path__ + "img/nepa_loading.7a916108.gif";